import { firestoreRef, authRef, functionsRef } from "api";

const examRef = firestoreRef.collection("exams");

async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

export async function getExams(onData) {
  examRef
    .where("endTime", ">", new Date().getTime())
    .orderBy("endTime", "desc")
    .onSnapshot(async data => {
      var exams = data.docs
        .map(doc => doc.data())
        .filter(i => i.status === "started" || i.status === "scheduled");

      await asyncForEach(exams, async exam => {
        try {
          exam.quiz = await getUserQuizes(
            exam.paperKey,
            exam.paperName,
            exam.examKey
          );
        } catch (e) {
          exam.quiz = null;
        }
      });
      onData(exams);
    });
}

export async function getUserQuizes(paperKey, paper_name, examKey) {
  let quizes = await firestoreRef
    .collection("live_quiz")
    .where("uid", "==", authRef.currentUser.uid)
    .where("paperKey", "==", paperKey)
    .where("examKey", "==", examKey)
    .get();
  let quiz = quizes.docs.map(i => i.data()).filter(i => i.paperKey)[0];
  return quiz;
}

export async function buyAnExam(value, detail) {
  var response = await createTransaction({
    value,
    detail
  });
  return response.data;
}

const createTransaction = functionsRef.httpsCallable("createTransaction");

export async function createQuiz(paperKey, paper_name, examKey, total_q = 100) {
  let uid = authRef.currentUser.uid;
  let ref = firestoreRef.collection("live_quiz").doc();

  let quiz = {
    key: ref.id,
    questionCount: total_q,
    startTime: new Date().getTime(),
    uid: uid,
    paperName: paper_name,
    paperKey,
    completed: false,
    examKey
  };

  await ref.set(quiz);

  return quiz;
}
